module.exports = __webpack_public_path__ + "img/banner_bg.e79ddd64.jpg";